import { Typography, Input, Select } from 'antd';
import { Link } from '../../../common/modalFooter/ModalFooter.styles';
import { Text } from '../../../../styles/common.styles';
import styled from 'styled-components';
import {
    blue01,
    grayLight02,
} from '../../../../styles/colors';

export const DocumentTypesTitle = styled(Typography.Text)`
    font-weight: 700;
    font-family: 'Proxima Nova';
    font-size: 14px;
    line-height: 18px;
    color: ${blue01};
    margin-left: 0px;
`;

export const TableDataContainer = styled('div')`
    display: flex;
    flex-direction: column;
    padding-bottom: 16px;
    gap: 16px;
`;

export const DtGroup = styled('div')`
   width: 600px;
   gap: 8px;
   padding: 0 0 8px 0;
   border-top: 1px solid ${grayLight02};
`;

export const DtBlock = styled('div')`
`;

export const DtRow = styled('div')`
    display: inline-flex;
    width: 100%;
//    height: 32px;
    border-bottom: 1px solid ${grayLight02};
`;

export const DtName = styled('div')`
    min-width: 470px;
    width: 470px;
    padding-top: 5px;
    padding-bottom: 5px;
    padding-right: 10px;
    a, p {
        font-family: Proxima Nova;
        font-size: 14px;
        font-weight: 400;
        line-height: 18px;
        text-align: left;
        text-decoration: none;
    }
    a {
        color: #134FBD;
    }
    p {
        color: #00273B
    }
    a:link {
      text-decoration: none;
    }
    a:visited {
      text-decoration: none;
    }
    a:hover {
      text-decoration: none;
    }
    a:active {
      text-decoration: none;
    }
`;

export const DtCmfContainer = styled('div')`
//    width: 100%;
    padding-top: 5px;
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    align-items: start;
`;

export const DtCmfImage = styled('div')`
`;

export const DtLink = styled(Link)`
    font-family: Proxima Nova;
    color: #00237B;
    font-weight: 400;
    margin-bottom: 0px;
    text-decoration: none !important;
`;

export const DtTitleWithoutLink = styled('p')`
    font-family: Proxima Nova;
    color: #00273B;
    font-size: 14px;
    font-weight: 400;
    margin-bottom: 0px;
`

export const FilterInput = styled(Input)`
    height: 28px !important;
    width: 164px !important;
    font-size: 14px;
    line-height: 18px;
`;

export const FilterLabel = styled(Text)`
    font-size: 12px;
    line-height: 14px;
`;
 export const DocTypesAndPaginationContainer = styled('div')`
    display: flex;
    align-items: center;
    justify-content: space-between;
 `;

 export const DocTypesConatiner = styled('div')`
    display: flex;
 `;

 export const FilterAreaContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 24px;
 `;

 export const FilterContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
 `;

 export const ImpactAreaFilter = styled(Select)`
    .ant-select-selector {
        width: 175px !important;
        height: 28px !important;
    }

    input {
        height: 26px !important;
    }

    .ant-select-selection-item {
        display: flex;
        align-items: center;
    }
 `;
